/* eslint-disable @typescript-eslint/camelcase */

import { domain, clientId } from "./auth_config.json";
import Vue from "vue";

import AuthUtil from "@/auth/authUtil";

export const setup = async (): Promise<AuthUtil> => {
  const authUtil = new AuthUtil();
  return await authUtil
    .init({
      domain: domain,
      client_id: clientId,
    })
    .then(() => {
      Vue.prototype.$auth = authUtil;
      return authUtil;
    });
};

export default setup;
